import React from "react"
import PropTypes from "prop-types"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
import InputAdornment from "@material-ui/core/InputAdornment"
import IconButton from "@material-ui/core/IconButton"
import Visibility from "@material-ui/icons/Visibility"
import VisibilityOff from "@material-ui/icons/VisibilityOff"

// @material-ui/icons
// import Email from "@material-ui/icons/Email"
import AccountCircleIcon from "@material-ui/icons/AccountCircle"
// import LockOutline from "@material-ui/icons/LockOutline";

import { APIPost, APIGet } from "services/APIRequest"
import * as Alert from "alertService"
import { SuccessCallback } from "services/alertService"
import UrlServer from "configs/UrlServer"
import Auth from "auth"
import Language from "language"
import Configs from "services/ConfigHost"

// core components
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import CustomInput from "components/CustomInput/CustomInput.jsx"
import Button from "components/CustomButtons/Button.jsx"
import Card from "components/Card/Card.jsx"
import CardBody from "components/Card/CardBody.jsx"
import CardHeader from "components/Card/CardHeader.jsx"
import CardFooter from "components/Card/CardFooter.jsx"
import Select from "components/CustomSelects/Select.jsx"
import FormLabel from "@material-ui/core/FormLabel"

import flag_TH from "assets/img/flags/TH.png";
import flag_EN from "assets/img/flags/GB.png";
import flag_JP from "assets/img/flags/JP.png";
import flag_CN from "assets/img/flags/CN.png";
import logo from "assets/img/mocap_logo.png";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx"
var iv = null
class LoginPage extends React.Component {
  constructor(props) {
    super(props)
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      username: "",
      password: "",
      showPassword: false,
      language: "TH",
      SelectListLanguage: [],
    }
  }
  componentDidMount() {
    // window.open('https://support.wwf.org.uk', "_blank")
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function () {
        this.setState({ cardAnimaton: "" })
      }.bind(this),
      500
    )
    this.loadLanguage(() => {
      this.onLoadStatus()
    })
    iv = setInterval(() => {
      this.onLoadStatus()
    }, 30000);
  }
  loadLanguage = (callback) => {
    APIPost(UrlServer.URL_GET_LANGUAGE_GET_ALLOW_LANGUAGE, {}, ({ datas }) => {
      var _SelectListLanguage = []

      if (datas && datas.length > 0) {
        datas.map((row) => {
          switch (row.key) {
            case "TH":
              if (row.active) {
                _SelectListLanguage.push({ name: <span> <img src={flag_TH} alt="..." /> [ TH ] Thailand</span>, value: "TH" })
              }
              break;
            case "EN":
              if (row.active) {
                _SelectListLanguage.push({ name: <span> <img src={flag_EN} alt="..." /> [ EN ] English</span>, value: "EN" })
              }
              break;
            case "JP":
              if (row.active) {
                _SelectListLanguage.push({ name: <span> <img src={flag_JP} alt="..." /> [ JP ] Jengapanese</span>, value: "JP" })
              }
              break;
            case "CN":
              if (row.active) {
                _SelectListLanguage.push({ name: <span> <img src={flag_CN} alt="..." /> [ CN ] China</span>, value: "CN" })
              }
              break;
          }
        })
      }
      this.setState({
        SelectListLanguage: _SelectListLanguage,
      }, () => {
        callback()
      });
    })
  }
  writeTranslate = (callback) => {
    APIPost(UrlServer.URL_GET_LANGUAGE_GET_TRANSLATE_DATA, {}, ({ datas }) => {
      var obj = {}
      if (datas) {
        datas.map((row) => {
          obj[row.original_txt.toLowerCase()] = row
        })
      }
      Language.setTranslate(obj)
      callback()
    })
  }
  onLoadStatus = () => {
    var startCountTime = new Date().getTime()
    var endCountTime = 0
    APIGet(UrlServer.URL_GET_APP_STATUS_DATA_BASE_STATUS, (datas) => {
      endCountTime = new Date().getTime()
      this.setState({
        statusAPI: true,
        statusDB: datas.statusDB,
        statusGoogle: datas.statusGoogle,
        statusPingSpeed: endCountTime - startCountTime,
      })
    }, (res) => {
      this.setState({
        statusAPI: false,
        statusDB: null,
        statusGoogle: null,
        statusPingSpeed: null,
      })
    })
  }
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction)
    this.timeOutFunction = null
  }

  handleChangeState = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }

  handlePressEnter = e => {
    if (e.charCode === 13) {
      this.submitLogin()
    }
  }

  handleSubmitLogin = () => {
    this.submitLogin()
  }
  handleOnloadManual = () => {
    document.location = Configs.FILE_PATH + "user_manual _nespresso_sms.pdf"
  };
  submitLogin() {
    // console.log('submitLogin >>>>', this.state)
    const dataForlogin = {
      username: this.state.username,
      password: this.state.password
    }
    Alert.Loading(true)
    APIPost(UrlServer.URL_AUTH_LOGIN, dataForlogin, (datas) => {
      var dataRes = datas.datas
      if (dataRes && dataRes.userData.dealer_code && dataRes.userData.user_type_code == 4) {
        APIPost(UrlServer.URL_POST_BRANCH_CODE_TO_NAME, {
          code: dataRes.userData.dealer_code
        }, (datas2) => {
          dataRes.userData.branch_name = datas2.data
          Language.setLanguage(this.state.language)
          Auth.setUserData(dataRes)
          Alert.LoadingClose()
          SuccessCallback("ลงชื่อเข้าใช้ระบบสำเร็จ", 2000, () => {
            this.writeTranslate(() => {
              window.location.reload()
            })
          })
        })
      } else {
        Language.setLanguage(this.state.language)
        Auth.setUserData(dataRes)
        Alert.LoadingClose()
        SuccessCallback("ลงชื่อเข้าใช้ระบบสำเร็จ", 2000, () => {
          this.writeTranslate(() => {
            window.location.reload()
          })
          // this.props.history.push("/dashboards/inboundApp/calling")
        })
      }
    })
  }
  handleMouseDownPassword = event => {
    event.preventDefault()
  }
  handleClickShowPassword = () => {
    this.setState(state => ({ showPassword: !state.showPassword }))
  }

  render() {
    const { classes } = this.props
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={4}>
            <center>
              <img src={logo} alt="logo" className={classes.img + " logo-login"} />
            </center>
          </GridItem>
        </GridContainer>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={4}>
            <form>
              <Card login className={classes[this.state.cardAnimaton]}>
                <CardHeader
                  className={`${classes.cardHeader} ${classes.textCenter}`}
                  color="info"
                >
                  <h4 className={classes.cardTitle}>ลงชื่อเข้าใช้ระบบ</h4>
                  {/* <small className={classes.cardTitleDescription}>
                    ของผู้ดูแลระบบเท่านั้น
                  </small> */}
                </CardHeader>
                <CardBody>
                  <CustomInput
                    labelText="ชื่อเข้าใช้งาน"
                    id="username"
                    formControlProps={{
                      onChange: this.handleChangeState("username"),
                      onKeyPress: this.handlePressEnter,
                      fullWidth: true
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <AccountCircleIcon
                            className={
                              classes.inputAdornmentIcon +
                              " " +
                              classes.iconMargin +
                              " " +
                              classes.iconMute
                            }
                          />
                        </InputAdornment>
                      )
                    }}
                  />
                  <CustomInput
                    labelText="รหัสผ่าน"
                    id="password"
                    formControlProps={{
                      onChange: this.handleChangeState("password"),
                      onKeyPress: this.handlePressEnter,
                      fullWidth: true
                    }}
                    inputProps={{
                      type: this.state.showPassword ? "text" : "password",
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={this.handleClickShowPassword}
                            onMouseDown={this.handleMouseDownPassword}
                          >
                            {!this.state.showPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                  <small className={"txt-c-b1"}>
                    เลือกภาษา
                  </small>
                  <div className="language-selection">
                    {
                      (this.state.SelectListLanguage.length > 0) ?
                        <Select
                          size="sm"
                          value={this.state.language}
                          listData={this.state.SelectListLanguage}
                          onChange={this.handleChangeState("language")}
                        />
                        : ""
                    }
                  </div>
                </CardBody>
                <CardFooter className={classes.justifyContentCenter}>
                  <Button
                    onClick={this.handleSubmitLogin}
                    color="primary"
                    simple
                    size="lg"
                    block
                  >
                    เข้าสู่ระบบ
                  </Button>
                  {/* <Button
                    onClick={e => this.handleOnloadManual()}
                    color="info"
                    simple
                    size="lg"
                    block
                  >
                    ดาวน์โหลดคู่มือ
                  </Button> */}
                </CardFooter>
              </Card>
            </form>
          </GridItem>
        </GridContainer>
        <div className="bar-app-status box-r1">
          <span> Version : </span> <span className="txt-c-bu3 m-r-3"> 1.3.0</span>
          <span> Last update date : </span> <span className="txt-c-bu3 m-r-3"> Y2022-M12-D28 18:00:00</span>
          <span> APP Connected to API : </span> {(this.state.statusAPI == null) ? <span className="txt-c-b1 m-r-3"> No checks</span> : (this.state.statusAPI) ? <span className="txt-c-g3 m-r-3"> Running </span> : <span className="txt-c-r m-r-3"> <b>Failed</b> </span>}
          <span> API Connected Database (MongoDB) : </span>  {(this.state.statusDB == null) ? <span className="txt-c-b1 m-r-3"> No checks</span> : (this.state.statusDB) ? <span className="txt-c-g3 m-r-3"> Running </span> : <span className="txt-c-r m-r-3"> <b>Failed</b> </span>}
          <span> API can ping Google : </span> {(this.state.statusGoogle == null) ? <span className="txt-c-b1 m-r-3"> No checks</span> : (this.state.statusGoogle) ? <span className="txt-c-g3 m-r-3"> Running </span> : <span className="txt-c-r m-r-3"> <b>Failed</b> </span>}
          <span> Speed of APP request to API and response time : </span>   {(this.state.statusPingSpeed == null) ? <span className="txt-c-b1 m-r-3"> No checks</span> : (this.state.statusPingSpeed) ? <span className="txt-c-g3 m-r-3"> {this.state.statusPingSpeed} Milliseconds </span> : <span className="txt-c-r m-r-3"> <b>Failed</b> </span>}
        </div>
      </div >
    )
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired
}
export default withStyles(loginPageStyle)(LoginPage)
